export const DATE_TIME_PATTERN = "YYYY-MM-DD HH:mm:ss";
export const DATE_PATTERN = "YYYY-MM-DD";
export const TIME_PATTERN = "HH:mm";
export const TIME_PATTERN_WITH_SEC = "HH:mm:ss";
export const DATE_TIME_WITHOUT_SECONDS_PATTERN = "YYYY-MM-DD HH:mm";
export const DATE_TIME_SOLIDUS_PATTERN = "DD/MM/YYYY HH:mm";
export const DATE_SOLIDUS_PATTERN = "DD/MM/YYYY";
